/* eslint-disable import/prefer-default-export */
import { CloudinaryImage } from '@cloudinary/url-gen';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { format } from '@cloudinary/url-gen/actions/delivery';
import { auto } from '@cloudinary/url-gen/qualifiers/format';
import { fill } from '@cloudinary/url-gen/actions/resize';
import ICloudConfig from '@cloudinary/url-gen/config/interfaces/Config/ICloudConfig';
import IURLConfig from '@cloudinary/url-gen/config/interfaces/Config/IURLConfig';

type Param = {
  width: number;
  height: number;
};

// Simple method to return a cloudinary image url for a fetched image
// param just suppors width and height but can be extended
export const getCloudinaryImageUrl = (public_id: string, param: Param, cloudConfig?: ICloudConfig, urlConfig?: IURLConfig) => {
  const image = new CloudinaryImage(
    public_id,
    { cloudName: 'zicasso', ...cloudConfig && { ...cloudConfig } },
    urlConfig,
  )
    .resize(
      fill()
        .width(param.width)
        .height(param.height)
        .gravity(autoGravity()),
    )
    .delivery(format(auto()));

  return image.toURL();
};
